
export class Vtd {

    constructor() {
        console.log("VTD: loaded/enabled");
    }

    // called from utag snippets
    postTrackingEvent(name, payload) {
        window.console.log("VTD: postTrackingEvent: name, payload", name, payload)
        return true;
    }

    filterUndefined(value) {
        if (value === 0) {
            return "0";
        }
        let string =  (typeof value === "undefined" || value == "undefined") ? '' : value;
        if (string) {
            string =  string.toString().substring(0, 30);
        }
        return string;
    }

    adobeSource(rawKey) {
        let source = "";
        if (rawKey) {
            if (rawKey.match(/^{data/)) {
                source = "data";
            }
            if (rawKey.match(/^{utag/)) {
                source = "utag";
            }
        }
        return source;
    }

    adobeKey(rawKey) {
        let key = rawKey;
        if (!rawKey) {
            return '';
        }
        if (rawKey.match(/^{data/)) {
            key = rawKey.match(/^{data\.(.*)}$/)[1];
        }
        if (rawKey.match(/^{utag/)) {
            key = rawKey.match(/^{utag\.(.*)}$/)[1];
        }
        return key;
    }

    // refactor key
    adobeValue(rawKey) {
        let key = rawKey;
        if (!rawKey) {
            return '';
        }
        if (rawKey.match(/^{data/)) {
            key = rawKey.match(/^{data\.(.*)}$/)
            return vtg.ts.snapshot[key[1]];
        }
        if (rawKey.match(/^{utag/)) {
            key = rawKey.match(/^{utag\.(.*)}$/)
            return utag_data[key[1]];
        }
        return '';
    }

    debug() {

        var smartTagEnabled = typeof SmartTag != "undefined";
        if (!smartTagEnabled) {
            console.log("VTD: smartTag NOT enabled");
        }
        var vtgEnabled = typeof vtg != "undefined";
        if (!vtgEnabled) {
            console.log("VTD: vtg NOT enabled");
        }

        var utag;
        var smartTag;
        var shaka;

        // find relevant javascripts
        Array.from(document.scripts).forEach(script => {
            if (script.src.match(/utag\.js/)) {
                utag = script.src;
            }
            if (script.src.match(/smart\.tag\.js/)) {
                let url = script.src;
                let parts = url.split('?');
                smartTag = parts[0];
            }
            if (script.src.match(/shaka/)) {
                shaka = script.src;
            }
        });

        let keys = [];
        // get the keys
        Object.keys(utag_data).forEach(e => keys[e] = 1);

        if (smartTagEnabled) {
            Object.keys(SmartTag.list[0].params.CONTEXT.metadata).forEach(e => keys[e] = 1)
        }
        if (typeof vtg != "undefined") {
            Object.keys(vtg.ts.snapshot).forEach(e => keys[e] = 1);
            Object.keys(vtg.config.AdobeMedia.params.customData).forEach(e => keys[e] = 1);
        }
        keys = keys.sort();
        // console.log(keys);



        var panel = open('url','_blank');
        panel.document.write(
            '<!doctype html>\n' +
            '<html lang="en">\n' +
            '<head>\n' +
            '<meta charset="utf-8">\n' +
            '<meta name="viewport" content="width=device-width, initial-scale=1">\n' +
            '<title>VTD - Video Tracking Debugger</title>\n' +
            '</head>\n' +
            '<body>\n'
        );

        panel.document.write(
            '<table>' +
            '<tr>' +
            '<td class="header" colspan="2">' +
            'environment' +
            '</td>' +
            '</tr>'
        );

        panel.document.write(
            '<tr>' +
            '<td>' +
            'page' +
            '</td>' +
            '<td>' +
            '<a href="' + window.location.href + '" target="_blank">' + window.location.href + "</a>" +
            '</td>' +
            '</tr>'
        );

        panel.document.write(
            '<tr>' +
            '<td>' +
            'utag' +
            '</td>' +
            '<td>' +
            '<a href="' + utag + '" target="_blank">' + utag + "</a>" +
            '</td>' +
            '</tr>'
        );

        if (smartTagEnabled) {
            panel.document.write(
                '<tr>' +
                '<td>' +
                'smartTag' +
                '</td>' +
                '<td>' +
                '<a href="' + smartTag + '" target="_blank">' + smartTag + "</a> " +
                SmartTag.info.version +
                '</td>' +
                '</tr>'
            );
        }

        if (vtgEnabled && typeof avia != "undefined") {
            console.log("VTD: vtgEnabled?", vtgEnabled);
            panel.document.write(
                '<tr>' +
                '<td>' +
                'avia' +
                '</td>' +
                '<td>' +
                avia.buildInfo.playerVersion +
                '</td>' +
                '</tr>'
            );
        }


        // if (vtgEnabled && typeof avia != "undefined") {
        //     panel.document.write(
        //         '<tr>' +
        //         '<td>' +
        //         'shaka' +
        //         '</td>' +
        //         '<td>' +
        //         shaka +
        //         '</td>' +
        //         '</tr>'
        //     );
        // }

        panel.document.write(
            '<tr>' +
            '<td>' +
            'API' +
            '</td>' +
            '<td>' +
            CBS.Registry.apiHost +
            '</td>' +
            '</tr>'
        );

        if (vtgEnabled && smartTagEnabled) {
            panel.document.write(
                '<tr>' +
                '<td>' +
                'sparrow' +
                '</td>' +
                '<td>' +
                CBS.Registry.sparrowHost +
                '</td>'
            );
        }
        panel.document.write(
            '</tr>'
        );
            // Sparrow URL
        // vtg.config.Sparrow.params.serverInfo.serverUrl
        // or
        // CBS.Registry.sparrowHost

        // what about API host?

        // CBS.Registry.imageHost

        // CBS.Registry.apiHost

        panel.document.write(
            "</table>"
        );

        panel.document.write(
            '<style type="text/css">' +
                'tr:nth-child(even) {background: #eee}' +
                'tr:nth-child(odd) {background: #FFF}' +
                'table {width: 100%; font-family: Courier; font-size: 12px; margin-bottom: 10px}' +
                'table, th, td {border: 1px solid;}' +
                'td {padding: 4px}' +
                'td {width: auto; overflow: hidden; vertical-align: top; white-space: nowrap }' +
                'td.header {font-weight: bold; text-align: center; color: white; background-color: black} ' +
                'td.bold {font-weight: bold}' +
                'td.good {background-color: lightgreen}' +
                'td.warn {background-color: lightpink}' +
                'table {border-collapse: collapse;}' +
            '</style>'
        );
        panel.document.write(
            '<table>' +
            '<tr>' +
            '<td class="header">' +
            // 'key' + "(" + Object.keys(keys).length + ")" +
            'key' +
            '</td>' +
            '<td class="header">' +
            'utag_data' +
            '</td>'
        );
        if (vtgEnabled && smartTagEnabled) {
            panel.document.write(
                '<td class="header">' +
                'smartTag CONTEXT' +
                '</td>' +
                '<td class="header">' +
                'vtg data' +
                '</td>' +
                '<td class="header">' +
                'adobe value' +
                '</td>' +
                '<td class="header">' +
                'adobe key' +
                '</td>'
            );
            panel.document.write(
                '</tr>'
            );
        }

        Object.keys(keys).sort().forEach(key => {
            if (key.match(/^_/)) {
                return;
            }
            if (key.match(/^cp\./)) {
                return;
            }
            if (key.match(/^meta\./)) {
                return;
            }
            if (key.match(/^tealium_/)) {
                return;
            }
            if (key.match(/^ut\./)) {
                return;
            }
            if (key.match(/^dom./)) {
                return;
            }

            let k = key;
            let u = this.filterUndefined(utag_data[key]);
            let s = null;
            if (smartTagEnabled) {
                s = this.filterUndefined(window.SmartTag.list[0].params.CONTEXT.metadata[key]);
            }

            let v = null;
            let a = null;
            let c = null;
            let ak = null;
            let source = null;

            try {
                if (vtgEnabled && typeof vtg.ts != "undefined" && typeof vtg.ts.snapshot != "undefined" && typeof vtg.config != "undefined") {
                    v = this.filterUndefined(vtg.ts.snapshot()[key]);
                    a = this.filterUndefined(this.adobeValue(vtg.config.AdobeMedia.params.customData[key]));
                    c = this.filterUndefined(vtg.config.AdobeMedia.params.customData[key]);

                    ak = this.adobeKey(vtg.config.AdobeMedia.params.customData[key]);
                    source = this.adobeSource(vtg.config.AdobeMedia.params.customData[key]);
                } else {
                }
            } catch (e) {
            }


            let kClass = "bold";
            let aClass = "";
            let vClass = ""

            if (a === "0" || a) {
                aClass = "good";
            } else {
                if (ak && u && s && !v) {
                    aClass = "warn";
                    if (source == "data") {
                        vClass = "warn";
                    }
                }
                // if (ak && u && s && v) {
                //     aClass = "warn";
                // }
            }

            // if (!ak && !u && !s && !v) {
            if (!ak) {
                return;
            }

            panel.document.write(
                '<tr>' +

                '<td class="' + kClass + '">' +
                k +
                '</td>' +

                '<td>' +
                u +
                '</td>'
            );

            if (vtgEnabled && smartTagEnabled) {
                panel.document.write(
                    '<td>' +
                    s +
                    '</td>' +

                    '<td class="' + vClass + '">' +
                    v +
                    '</td>' +

                    '<td class="' + aClass + '">' +
                    a +
                    '</td>' +

                    '<td>' +
                    c +
                    '</td>'
                );
            }

            panel.document.write(
                '</tr>'
            );
        });

        panel.document.write(
            '</table>'
        );

        panel.document.write(
            '</body>' +
            '</html>'
        );

        return true;
    }
}
